import React from "react"

import { ReadOnly } from "@tenforce/toolbox-field-react"

import { IOption, IQuestion } from "../../.."

export type Props = IQuestion

export const ReadOnlyValue = ({ data, type }: Props): JSX.Element => {
    let value = ""
    switch (type) {
        case "Date":
        case "Time":
        case "Number":
        case "Text":
            value = data as string
            break
        case "MultiPicker":
        case "SinglePicker":
        case "ToggleButton":
            value = (data as IOption[])
                .filter((option) => option.isSelected)
                .map((option) => option.label)
                .join(", ")
            break
        default:
            return <></>
    }

    return <ReadOnly value={value} title={value} data-ft-component="readonly" />
}

export default ReadOnlyValue
